export class Constants{
  public static Locations = {
    CreateNew: -1,
    NotSelected: -10
  }
}